import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class MutationObserverService {
	waitForElement(
		parentElement: Element,
		targetElementSelector: string,
		timeoutSeconds?: number
	): Observable<Element | undefined> {
		const elementSubject = new Subject<Element | undefined>();

		// If the element already exists return an observable with the existing element
		const existingElement = parentElement.querySelector(targetElementSelector);
		if (existingElement) {
			return of(existingElement);
		}

		// The element doesn't exist yet.  Observe child elements being created on the parent element and as soon
		// as the target element has been created, trigger the observable
		const mutationObserver = new MutationObserver(() => {
			const element = parentElement.querySelector(targetElementSelector);

			if (element) {
				elementSubject.next(element);
				mutationObserver.disconnect();
			}
		});

		mutationObserver.observe(parentElement, {
			attributes: false,
			childList: true,
			subtree: true,
		});

		const timeoutMilliSeconds = (timeoutSeconds ?? 10) * 1000;

		// If the target element isn't created in the timeout period, disconnect from the mutation observer
		setTimeout(() => {
			elementSubject.next(undefined);
			mutationObserver?.disconnect();
		}, timeoutMilliSeconds);

		return elementSubject.asObservable();
	}
}
